import {sendNotification} from "./";

export const sortFunctionalitites = (data) => {
  const newData = data.map(e => ({
    ...e,
    id: e._id
  }))
  const usersGroup =  newData.filter(e => e.type === "1");
  const storageGroup =  newData.filter(e => e.type === "2");
  const funcGroup =  newData.filter(e => e.type === "3");
  const usersFree = usersGroup.filter(e => e.is_free === "true").map(e => ({
    ...e,
    is_first: true
  }));
  const usersNotFree = usersGroup.filter(e => e.is_free === "false");
  const storageFree = storageGroup.filter(e => e.is_free === "true").map(e => ({
    ...e,
    is_first: true
  }));
  const storageNotFree = storageGroup.filter(e => e.is_free === "false");

  const newFuncGroup = funcGroup.length === 1 ? [{
    ...funcGroup[0],
    is_first: true
  }] : funcGroup.length > 1 ? [
    {
      ...funcGroup[0],
      is_first: true
    },
    ...funcGroup.slice(1)
  ] : funcGroup;
  
  return [
    ...usersFree,
    ...usersNotFree,
    ...storageFree,
    ...storageNotFree,
    ...newFuncGroup
  ];
}

export const calculateDiff = (userServices, data) => {
  const cleanData = data.filter(e => e.key !== -1)
  const diff = [];
  for(let i = 0; i < userServices.length; i++){
    const userService = userServices[i];
    const found = cleanData.find(e => e._id === userService.idService);
    if(found){
      const diffValue = found.quantity - userService.quantity;
      if(diffValue !== 0){
        diff.push({
          ...userService,
          quantity: found.quantity - userService.quantity
        });
      }
    }else{
      diff.push({
        ...userService,
        quantity: -userService.quantity
      });
    }
  }
  const userServicesIds = userServices.map(e => e.idService);
  const newData = cleanData.filter(e => !userServicesIds.includes(e._id));
  for(let i = 0; i < newData.length; i++){
    diff.push({
      ...newData[i],
      quantity: newData[i].quantity
    });
  }
  return diff;
}

export const updateClientPlans = (client, intl, data, dataDiff, usersData, planServices) => {
  const {name, dni, dartCustomField, contractedUsers, contractedSpace} = client;
  const companyName = name;

  if (!companyName || !dni || !dartCustomField || !contractedUsers || !contractedSpace) {
    sendNotification('error', intl, intl.formatMessage({id: 'enter_required_fields'}));
    return {
      action: "none"
    };
  }

  const registeredUsers = usersData.filter(
    (user) =>
      user.status &&
      user.typeRoleFilter === 'Infinite' &&
      user.email.indexOf('@bunkey.tv') === -1 &&
      user.roleLower !== 'superadmin'
  ).length;

  
  const usersPlansContracted = data.filter(e => e.type === "1").map(e => e._id);
  // const storagePlansContracted = data.filter(e => e.item === "capacidad almacenamiento").map(e => e._id);
  const planServicesWithQuantity = planServices.map(e => {
    const found = data.find((elementData) => elementData._id === e._id )
    if(found){
      return ({
        ...e,
        quantity: found.quantity
      })
    }
    return e
  })
  const toBuyUsersList = planServicesWithQuantity.filter(e => {
    return usersPlansContracted.includes(e._id)
  })
  // const toBuyStorageList = planServicesWithQuantity.filter(e => {
  //   return storagePlansContracted.includes(e._id)
  // })
  
  const toBuyUsers = toBuyUsersList.reduce((total, value) => {
    return total + value.space * value.quantity;
  }, 0)

  // const toBuyStorage = toBuyStorageList.reduce((total, value) => {
  //   return total + value.space * value.quantity;
  // }, 0)

  const freeUsers = data.filter(e => e.is_free === "true" && e.type === "1").reduce((total, value) => {
    return total + value.quantity;
  }, 0)

  // const freeStorage = data.filter(e => e.is_free === "true" && e.item === "capacidad almacenamiento").reduce((total, value) => {
  //   return total + value.quantity;
  // }, 0)

  const totalToBuyUsers = toBuyUsers + freeUsers;
  // const totalToBuyStorage  = toBuyStorage + freeStorage;

  if(totalToBuyUsers < registeredUsers){
    sendNotification('error', intl, "Para contratar menos usuarios de los actualmente registrados, debe eliminar usuarios");
    return {
      action: "none"
    };
  }

  const totalPrice = dataDiff.reduce((total, value) => {
    return total + value.price * value.quantity;
  }, 0);

  if(totalPrice <= 0){
    const totalPriceCurrent = data.reduce((total, value) => {
      if (value.key !== -1) {
        return total + value.price * value.quantity;
      }else{
        return total;
      }
    }, 0);
    return {
      action: "reduce_plan",
      data: {
        amount: totalPriceCurrent
      }
    };
  }

  const modules = data.map(x => ({ idService: x.idService ? x.idService : x._id, quantity: x.quantity }))

  return {
    action: "update_plan",
    data: {
      modules: modules,
      amount: totalPrice
    }
  };

}

export const isEnterpriseUser = (client) => {
  return client ? client.isEnterprise : false;
}
